import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import Chart from 'chart.js';
import { fromUTC } from 'helpers/dates';

class CargoRequestsChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            chart: {},
        };
    }

    componentDidMount() {
        this.createRangeDates(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.createRangeDates(nextProps);
    }

    createRangeDates(props) {
        let { chart } = this.state;
        const { statistics } = props;

        const labels = [];
        const requests = [];
        const fromApi = [];
        const fromFix = [];
        const fromVaramar = [];
        const fromBroker = [];
        statistics.forEach((request) => {
            labels.push(moment(fromUTC(request.date)).format('MM-DD-YYYY'));
            requests.push(request.quantity - request.fromApi - request.fromFix - request.fromVaramar - request.fromBroker);
            fromApi.push(request.fromApi || 0);
            fromFix.push(request.fromFix || 0);
            fromVaramar.push(request.fromVaramar || 0);
            fromBroker.push(request.fromBroker || 0);
        });

        const datasets = [
            {
                label: 'Connect',
                backgroundColor: '#ECC30B',
                borderColor: '#ECC30B',
                data: fromApi,
            },
            {
                label: 'Varamar',
                backgroundColor: '#D62C2F',
                borderColor: '#D62C2F',
                data: fromVaramar,
            },
            {
                label: 'Fix',
                backgroundColor: '#F37748',
                borderColor: '#F37748',
                data: fromFix,
            },
            {
                label: 'Broker',
                backgroundColor: '#2B9EB3',
                borderColor: '#2B9EB3',
                data: fromBroker,
            },
            {
                label: 'Others',
                backgroundColor: 'blue',
                borderColor: 'blue',
                data: requests,
            },
        ];

        if (_.isEmpty(chart)) {
            chart = this.createChart(labels, datasets);
        } else {
            chart = this.updateChart(chart, labels, datasets);
        }

        this.setState({
            chart,
        });
    }

    updateChart(chart, labels, datasets) {
        chart.data.labels = labels;
        chart.data.datasets = datasets;

        chart.update(0);

        return chart;
    }

    createChart(labels, datasets) {
        const ctx = this.refs.chart.getContext('2d');
        const chart = new Chart(ctx, {
            type: 'bar',
            data: {
                labels,
                datasets,
            },
            options: {
                tooltips: {
                    mode: 'label',
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                    }],
                    yAxes: [{
                        stacked: true,
                    }],
                },
            },
        });

        return chart;
    }

    render() {
        return (
            <canvas ref='chart' />
        );
    }
}

export default connect(
    ({ statisticsCargoRequests: { items } }, { from, until }) => {
        return {
            statistics: items,
            from,
            until,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(CargoRequestsChart);



// WEBPACK FOOTER //
// ./app/components/Statistics/Monitor/CargoRequestsChart.jsx